import React, { useState, useEffect } from "react";
import {
  CircularProgress,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
} from "@mui/material";
import { SlReload } from "react-icons/sl";
import { FaFileCsv } from "react-icons/fa";

import {
  StyledTableCell,
  StyledTableRow,
} from "../../Components/MaterialTableStyle/StyleTableCell";

import { csvDownload } from "../../Components/CsvandPdfDownload/CsvDownload"
import CustomTooltip from "../../Components/Input/CustomToolTip";
import { IoSearchOutline } from "react-icons/io5";
import Enshield from "../../Assets/images/logo.svg";
import ETHLogo from "../../Assets/logos/ETHLogo.png";
import USDTLogo from "../../Assets/logos/USDTLogo.png";
import CustomText_input from "../../Components/Input/CustomText_input";
import { FormatDate } from "../../Components/DateFormats/DateFromat";
import { toast } from "react-toastify";

import { REACT_APP_TRANSACTION_HASHLINK } from "../../Config/Config"

const PresaleTable = ({ PresaleData, presaleReload }) => {
  const [InitialData, setInitialData] = useState([]);
  const [Loader, setLoader] = useState(false);
  const [SearchQuery, setSearchQuery] = useState("");
  useEffect(() => {
    setInitialData(PresaleData);
    setLoader(true);
  }, [PresaleData]);

  var formatter = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 3,
  });

  useEffect(() => {
    if (Loader) {
      setTimeout(() => {
        setLoader(false);
      }, 1000);
    }
  }, [Loader]);

  const HandleSearch = (e) => {
    const Datas = [...PresaleData];
    setSearchQuery(e);
    let filetedsearch = Datas.filter(
      (a) =>
        a?.transactionHash?.toLowerCase().includes(e?.toLowerCase()) ||
        a?.user?.toLowerCase().includes(e?.toLowerCase()) ||
        a?.amount?.toLowerCase().includes(e?.toLowerCase()) ||
        a?.tokenamount?.toLowerCase().includes(e?.toLowerCase())

    );
    setInitialData(filetedsearch);
  };

  const dowanloadcsv = async()=>{

    if(InitialData?.length > 0){
      console.log("InitialData==>",InitialData)

      let arr = []
      InitialData?.map((row) => {
        arr.push([row?.user,row?.tokenamount,4])
      })

      const csvheaderData = [
        ["wallet", "amount", "saletype"],
        ...arr
      ]

      csvDownload(csvheaderData, "Presale Wallet");

    }else{
      toast.warn("Data Not Available")
    }

  }
  return (
    <Grid
      container
      lg={12}
      display={"flex"}
      flexDirection={"row"}
      alignItems={"flex-start"}
      justifyContent={"flex-start"}
      // className="walletAction_Card mt-3 p-3"
      className="mt-3 p-3"
    >
      <Grid
        container
        lg={12}
        display={"flex"}
        flexDirection={"row"}
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        <Grid item lg={6}>
          <h5 className="text-left">Presale</h5>
        </Grid>
        <Grid
          item
          lg={6}
          display={"flex"}
          alignItems={"center"}
          justifyContent={"flex-end"}
        >
          <Grid item sm={6} xs={6}>
            <CustomText_input
              placeholder={"Search..."}
              isBorder={true}
              borderColor={"#fff"}
              Value={SearchQuery}
              HandleInput={(e) => HandleSearch(e)}
              StartIcon={<IoSearchOutline className="text-light" size={25} />}
              height={"40px"}
            />
          </Grid>

          
          <Grid item>
            <button
              className="btn rounded mx-2 btn-0 GlassCard"
              onClick={() => {dowanloadcsv()}}
            >
              <FaFileCsv color="#FFED8C" size={"22px"} />
            </button>
          </Grid>

          <Grid item>
            <button
              className="btn rounded mx-2 btn-0 GlassCard"
              onClick={() => {setLoader(true);presaleReload()}}
            >
              <SlReload color="#FFED8C" size={"22px"} />
            </button>
          </Grid>
        </Grid>
      </Grid>
      <Grid
        container
        lg={12}
        display={"flex"}
        flexDirection={"column"}
        alignItems={"center"}
        justifyContent={"center"}
        className="mt-2"
      >
        <TableContainer
          className="customeScroll"
          sx={{border: "1px solid #FFFFFF1A",borderRadius:"15px", height: { lg: "70vh", sm: "50vh" }, overflowY: "auto" }}
        >
          <Table stickyHeader aria-label="sticky table">
            <TableHead root>
              <StyledTableRow>
                <TableCell
                  style={{
                    backgroundColor: "#3B3B3D",
                    color: "#FFF",
                    fontSize: "14px",
                    fontFamily: "PoppinsSemiBold",
                  }}
                >
                  No
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: "#3B3B3D",
                    color: "#FFF",
                    fontSize: "14px",
                    fontFamily: "PoppinsSemiBold",
                  }}
                >
                  Transaction Hash
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: "#3B3B3D",
                    color: "#FFF",
                    fontSize: "14px",
                    fontFamily: "PoppinsSemiBold",
                  }}
                >
                  Investor Address
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: "#3B3B3D",
                    color: "#FFF",
                    fontSize: "14px",
                    fontFamily: "PoppinsSemiBold",
                  }}
                >
                  Invest Amount
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: "#3B3B3D",
                    color: "#FFF",
                    fontSize: "14px",
                    fontFamily: "PoppinsSemiBold",
                  }}
                >
                  Amount Vested
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: "#3B3B3D",
                    color: "#FFF",
                    fontSize: "14px",
                    fontFamily: "PoppinsSemiBold",
                  }}
                >
                  Date & Time{" "}
                </TableCell>
              </StyledTableRow>
            </TableHead>
            {!Loader ? (
              InitialData?.length > 0 ? (
                <TableBody>
                  {InitialData?.map((row, i) => (
                    <StyledTableRow key={i} sx={{backgroundColor:i % 2 !== 0 ? "#FFFFFF0F" : "#343435CC",}}>
                      <StyledTableCell className="text-center">
                        <span>{i + 1}</span>
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTooltip title={row.transactionHash} placement="right">
                          {/* <span>
                            {row?.transactionHash?.slice(0, 8) +
                              "...." +
                              row?.transactionHash?.slice(-8)}
                          </span> */}
                          <a
                            href={
                              REACT_APP_TRANSACTION_HASHLINK +
                              row?.transactionHash
                            }
                            target="blank"
                            style={{ color: "#fff" }}
                          >
                            <span>
                              {row?.transactionHash?.slice(0, 8) +
                                "...." +
                                row?.transactionHash?.slice(-8)}
                            </span>
                          </a>
                        </CustomTooltip>
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTooltip
                          title={row.useraddress}
                          placement="right"
                        >
                          {" "}
                          <span>
                            {row?.useraddress?.slice(0, 8) +
                              "...." +
                              row?.useraddress?.slice(-8)}
                          </span>
                        </CustomTooltip>
                      </StyledTableCell>
                      <StyledTableCell>
                        <Grid
                          display={"flex"}
                          flexDirection={"row"}
                          alignItems={"center"}
                        >
                          { row?.ethAmount && Number(row?.ethAmount) > 0 ?
                            <>
                              <img
                                src={ETHLogo}
                                alt="coin"
                                style={{ height: "25px", width: "25px",borderRadius:"25px" }}
                              />
                              <span className="mx-1">
                                {row?.ethAmount ? row?.ethAmount : "----"}
                              </span>
                            </>
                            :""
                          }
                          { row?.ethAmount && Number(row?.ethAmount) > 0 && row?.usdtAmount && Number(row?.usdtAmount) > 0 ? <span className="mx-1"> / </span> :"" }
                          { row?.usdtAmount && Number(row?.usdtAmount) > 0 ?
                            <>
                              <img
                                src={USDTLogo}
                                alt="coin"
                                style={{ height: "25px", width: "25px",borderRadius:"25px" }}
                              />
                              <span className="mx-2">
                                {row?.usdtAmount ? row?.usdtAmount : "----"}
                              </span>
                            </>
                            :""
                          }
                          
                        </Grid>
                      </StyledTableCell>
                      <StyledTableCell>
                        <Grid
                          display={"flex"}
                          flexDirection={"row"}
                          alignItems={"center"}
                        >
                          <img
                            src={Enshield}
                            alt="coin"
                            style={{ height: "25px", width: "25px" }}
                          />
                          <span className="mx-2">
                            {formatter.format(row?.amount)}
                          </span>
                        </Grid>
                      </StyledTableCell>
                      <StyledTableCell>
                        <span>{FormatDate(row?.date)}</span>{" "}
                      </StyledTableCell>
                    </StyledTableRow>
                  ))}
                </TableBody>
              ) : (
                <TableBody>
                  <StyledTableRow>
                    <StyledTableCell colSpan={7} align="center">
                      <p className="text-center text-light">
                        No Presale Available
                      </p>
                    </StyledTableCell>
                  </StyledTableRow>
                </TableBody>
              )
            ) : (
              <TableBody>
                <StyledTableRow>
                  <StyledTableCell colSpan={7} align="center">
                    <span className="regular">
                      <CircularProgress style={{ color: "#FFFF" }} />
                    </span>
                  </StyledTableCell>
                </StyledTableRow>
              </TableBody>
            )}
          </Table>
        </TableContainer>
      </Grid>
    </Grid>
  );
};

export default PresaleTable;
